/** Facade page lookups that answer 404 when the requested slug does not exist. */
export const PAGE_ENDPOINTS = {
  productDetail: '/page/productDetail',
  collectionDetail: '/page/collectionDetail',
} as const;
